import React from "react";

export const Logo: React.FC<{ width: number; linked?: boolean }> = (props) => {
  const image = <img width={props.width} src="/home/logo.svg" alt="" />;
  return props.linked === true ? <a href="/">{image}</a> : image;
};
